"use client"

import {
  ChevronLeftIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/20/solid"
import Button from "@src/components/Button"
import { NearIcon } from "@src/icons"
import Link from "next/link"

export default function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-white dark:bg-gray-850">
      <div className="p-5 md:py-10">
        <Link href="/" className="flex items-center gap-2.5">
          <NearIcon className="size-12 shrink-0 text-black" />
          <span className="sr-only">Home</span>
        </Link>
      </div>

      <div className="flex grow flex-col items-center justify-center p-5 md:py-10 md:pb-42">
        <div className="rounded-xl bg-gray-900 px-2 py-1 font-bold text-base text-green-500 dark:bg-green-500/10">
          404
        </div>
        <h1 className="mt-4 text-pretty text-center font-semibold text-3xl/[1.1] text-gray-900 tracking-tight sm:mt-6 sm:text-4xl/[1.1] lg:text-5xl/[1.1] dark:text-white">
          This page does not exist
        </h1>
        <div className="mt-12 grid gap-2.5 sm:mt-16 sm:grid-cols-2">
          <Button size="xl" href="/">
            <ChevronLeftIcon className="size-5 shrink-0" />
            Back to home
          </Button>
          <Button
            size="xl"
            variant="secondary"
            onClick={() => {
              if (typeof window !== "undefined" && window.Beacon) {
                window.Beacon("open")
              }
            }}
          >
            <QuestionMarkCircleIcon className="size-5 shrink-0" />
            Contact support
          </Button>
        </div>
      </div>
    </main>
  )
}
